import axios from './axiosInstances/axiosInstance';

export const createBasketFromPreviousOrder = (orderId) => {
  return axios.post(`/baskets/fromOrder`, { orderId, ignoreUnavailableProducts: true });
};
